import styles from "./styles.mobile.module.scss";
import { LocalSearchBar } from "../../CustomComponents/LocalSearchBar";
import { GlobalSearchBar } from "../../CustomComponents/GlobalSearchBar";
import { ReactNode } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { isVitalsSubdomain } from "../../../util/subdomain";
export interface IProps {
  leftIcon: ReactNode;
  rightIcon: ReactNode;
  onClickSearch: () => void;
  title?: string;
}

export const Header: FC<IProps> = ({
  onClickSearch,
  leftIcon,
  rightIcon,
  title,
}) => {
  const location = useLocation();

  // Define pages that should use local search
  const localSearchPages = [
    "/clinical",
    "/bedexits",
    "/my-facility",
    "/motion-and-exits",
  ];

  const isLocalSearchPage = localSearchPages.includes(location.pathname);

  return (
    <>
      <div className={styles.container}>
        {!isVitalsSubdomain() ? (
          <div
            className={classNames(
              styles.searchBarCon,
              !rightIcon && styles.searchBarConNoRight
            )}
          >
            <div className={styles.searchCon} id="global-search">
              {isLocalSearchPage ? (
                <LocalSearchBar leftIcon={leftIcon} />
              ) : (
                <GlobalSearchBar
                  leftIcon={leftIcon}
                  onSearchClick={onClickSearch}
                />
              )}
            </div>
          </div>
        ) : (
          // Show only the menu icon when on vitals subdomain
          <div className={styles.searchBarCon}>
            <div className={styles.searchCon}>{leftIcon}</div>
          </div>
        )}
        {rightIcon}
      </div>
      {title && (
        <h5 className={styles.heading} id="main-heading">
          {title}
        </h5>
      )}
    </>
  );
};
